export const GetActivityCalendar = (locationId,poolId) => {

  return $.get('Patron/GetActivityCalendar?locationId='+locationId+'&poolId='+poolId)

}

export const GetLocations = () => {
  let havingPools=true;
  return $.get('Location/GetLocations?havingPools='+havingPools)

}
export const GetPools = (locationid) => {

  return $.get('Pool/GetPools?locationId='+locationid)

}




// WEBPACK FOOTER //
// ./src/components/ActivityCalender/calender.service.js